



































import Vue from "vue";
import AuthButtons from "@/components/AuthButtons.vue";
import globalState from "@/globalState";
import { RoleEnum } from "@/graphql/generatedTypes/globalTypes";
export default Vue.extend({
  name: "TopNav",
  components: {
    AuthButtons
  },
  apollo: {},
  data() {
    return {
      globalState,
      currentUser: this.$authRepository.getCurrentUser(),
      RoleEnum
    };
  },
  computed: {
    isLoading(): boolean {
      return this.globalState.loading > 0;
    }
  }
});
